import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { GaIncidentData, GaInventoryData, GaPreferenceData } from '@app/shared/pdf/ga-bitacoras';

/**
 * Datos de los formatos GA (bitácoras y control de inventario). El API los
 * calcula y los recorta por el rol (módulo) y el alcance (hospitales) del
 * usuario; aquí solo se piden.
 */
@Injectable({ providedIn: 'root' })
export class GaFormsService extends ApiBaseService<any> {
  constructor() { super('gaForms'); }

  private async get<R>(path: string, params: Record<string, string | null | undefined>): Promise<R> {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) if (v) q.set(k, v);
    const r: any = await this.request<R>(`gaForms/${path}?${q.toString()}`, 'GET');
    const data = r?.data?.[0];
    if (!data) throw new Error(r?.message || 'El servidor no regresó datos para el formato.');
    return data as R;
  }

  incident(id: string): Promise<GaIncidentData> {
    return this.get<GaIncidentData>('incident', { id });
  }

  doctorPreference(doctor: string, place?: string | null): Promise<GaPreferenceData> {
    return this.get<GaPreferenceData>('doctorPreference', { doctor, place });
  }

  /** date: AAAA-MM-DD · shifts: 'M,V' | 'V,N' | 'N' */
  inventoryControl(place: string, date: string, shifts: string): Promise<GaInventoryData> {
    return this.get<GaInventoryData>('inventoryControl', { place, date, shifts });
  }
}
